function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const ChevronRightIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0l-3 3 13 13-13 13 3 3 16-16-16-16z"
  }));
};
export default ChevronRightIcon;